//------------------------------ Responsive left column------------------
function responsivecolumn()
{
	if ($(document).width() <= 991)
	{
		$('.main-content.page-width .contents .side-bar').appendTo('.main-content.page-width .contents');
	}
	else if($(document).width() >= 992)
	{
		$('.main-content.page-width .contents .side-bar').prependTo('.main-content.page-width .contents');
	}
}
$(document).ready(function(){responsivecolumn(); });
$(window).resize(function(){responsivecolumn(); });

/*===================== account toggle ========================*/
$(document).ready(function(){
	$(".user-background").click(function(){
	$(".tm_headerlinkmenu .my-account").slideToggle(800); 
    $('.tm_headerlinkmenu').toggleClass('active'); 
	});
});

/*===================== cart toggle ========================*/
$(document).ready(function(){
	$(".header__cart-background").click(function(){
	$(".site-header__cart .cart-content.block").slideToggle(800); 
    $('.site-header__cart').toggleClass('active'); 
	});
});

//====================collection-list slider======================//
var topsliders = document.getElementById('collection-item-tm');
var topowl1 = $("#collection-item-tm");
$(topowl1).each(function (index) {
  topowl1.owlCarousel({
    items : 7, //10 items above 1000px browser width
    itemsDesktop : [1269,5], //5 items between 1000px and 901px
    itemsDesktopSmall : [989,4], // betweem 900px and 601px
    itemsTablet: [749,3], //2 items between 600 and 0
    itemsMobile : [479,2], // itemsMobile disabled - inherit from itemsTablet option
    autoPlay: true
  });
  $("a.next").click(function(){
    topowl1.trigger('owl.next');
  });
  $("a.prev").click(function(){
    topowl1.trigger('owl.prev');
  });
});

 //========================blog list slider==========================// 
    var blogowl = $("#blog_slider");
    blogowl.owlCarousel({
        items : 2, //10 items above 1000px browser width
        itemsDesktop : [1269,2], //5 items between 1000px and 901px
        itemsDesktopSmall : [989,2], // betweem 900px and 601px
        itemsTablet: [749,2], //2 items between 600 and 0
        itemsMobile : [479,1]  // itemsMobile disabled - inherit from itemsTablet option
    });
    $(".blog_next").click(function(){
    	blogowl.trigger('owl.next');
    });
    $(".blog_prev").click(function(){
    	blogowl.trigger('owl.prev');
    });

//========================brand list slider==========================//
var brandsowl = $("#brands_list_slider");
brandsowl.owlCarousel({
  auto: true,
  items : 5, //10 items above 1000px browser width
  itemsDesktop : [1269,5], //4 items between 1269px and 990px
  itemsDesktopSmall : [989,4], //4 items betweem 989px and 750px
  itemsTablet: [749,3], //2 items between 749 and 480
  itemsMobile : [479,2], // itemsMobile disabled - inherit from itemsTablet option
});
$(".brands_next").click(function(){
  brandsowl.trigger('owl.next');
});
$(".brands_prev").click(function(){
  brandsowl.trigger('owl.prev');
});

//==========================back-to-top=======================//
$(window).scroll(function() {
if ($(this).scrollTop() > 500) {
$('.top_button').fadeIn(500);
} else {
$('.top_button').fadeOut(500);
}
});	
$('.top_button').click(function(event) {
event.preventDefault();	
$('html, body').animate({scrollTop: 0}, 800);
});

//====================== collection tab =======================//
$(document).ready(function() {
    $('.product_tab-block ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });

//=================== thumnails slider ===================//
$(document).ready(function() {
    var addslider = $("#addition-slider");
  	  if ($(window).width() > 749){
        addslider.owlCarousel({
            items : 4, //10 items above 1000px browser width
            itemsDesktop : [1280,4], //5 items between 1000px and 901px
            itemsDesktopSmall : [990,3], // betweem 900px and 601px
            itemsTablet: [749,4], //2 items between 600 and 0
            itemsMobile : [479,2] // itemsMobile disabled - inherit from itemsTablet option
        });
        $(".add_next").click(function(){
            addslider.trigger('owl.next'); 
        });
        $(".add_prev").click(function(){
            addslider.trigger('owl.prev');
        });
      }
});  

//======================== Sticky header ======================//
function StickyHeader(){	
	"use strict";	
	var num = 130; //number of pixels before modifying styles
	
		jQuery(window).bind('scroll', function () {
			if (jQuery(window).scrollTop() > num) {
				jQuery('.header-fix').addClass('sticky-menu');
				jQuery('.site-header-fix').addClass('header-style');
				jQuery('.category-box').addClass('home-category-fix');
				jQuery('.home-category').addClass('home-category-fix1');
				
			} else {
				jQuery('.header-fix').removeClass('sticky-menu');		
				jQuery('.site-header-fix').removeClass('header-style');
				jQuery('.category-box').removeClass('home-category-fix');
			}
		})
}
jQuery(document).ready(function() { "use strict";   StickyHeader()});
jQuery(window).resize(function() {  "use strict";   StickyHeader()});

//====================== collection tab =======================//
$(document).ready(function() {
    $('.product-single__description ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });

/*==================sidebar toggle====================*/
function mobileToggleColumn1(){
  if ($(window).width() < 990){
    $(".side-bar h3.box-heading, .side-bar .categories_title").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar h3.box-heading, .side-bar .categories_title").addClass('toggle');
    $(".side-box .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').parent().find('.box-content').slideToggle('slow');
    });    
  }
  else{
    $(".side-bar h3.box-heading, .side-bar .categories_title").removeClass('toggle');
    $(".side-bar h3.box-heading, .side-bar .categories_title").removeClass('active');
    $(".side-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn1);

/*==================footer toggle====================*/
function mobileToggleColumn(){
  if ($(window).width() < 990){
    $(".site-footer .footer-box  h5").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".site-footer .footer-box h5").addClass('toggle');
    $(".footer-box .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').parent().find('.footer-content').slideToggle('slow');
    });    
  }
  else{
    $(".site-footer .footer-box  h5").removeClass('toggle');
    $(".site-footer .footer-box h5").removeClass('active');
    $(".footer-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn);

/*================== category-box ===================*/

/*================== category-box ===================*/
function mobileToggleMenu2(){
  if ($(window).width() >= 320){
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow');    
    });    
  }
  else
  {
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").removeClass('toggle')
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").removeClass('active');
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleMenu2);

function mobileToggleMenu3(){
  if ($(window).width() >= 320){
    $(" #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(" #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").addClass('toggle'); 
    $(" #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.grand-child-has-dropdown').slideToggle('slow'); 
    });    
  }
  else
  {
    $("#CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").removeClass('toggle')
    $("#CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").removeClass('active');
    $("#CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleMenu3);
/* ============================= hero insert after ====================*/

function addfl(){
	this.$owlItems.removeClass('first last');
	this.$owlItems.eq(this.currentItem).addClass('first');
	this.$owlItems.eq(this.currentItem + (this.owl.visibleItems.length - 1)).addClass('last');
}

/***************************** Product Tab collection slider *****************************/
//======================best seller collection slider======================//
var topsliders = document.getElementById('best-seller_products_slider');
var topowl3 = $("#best-seller_products_slider");
$(topowl3).each(function (index) {
  $(this).owlCarousel({
    items : 4, //10 items above 1000px browser width
    itemsDesktop : [1269,4], //5 items between 1000px and 901px
    itemsDesktopSmall : [989,3], // betweem 900px and 601px
    itemsTablet: [749,3], //2 items between 600 and 0
    itemsMobile : [479,2], // itemsMobile disabled - inherit from itemsTablet option
	afterAction: addfl
  });

  $(".best-seller_next").click(function(){
    $(topowl3).trigger('owl.next');
  });
  $(".best-seller_prev").click(function(){
    $(topowl3).trigger('owl.prev');
  });
});


//======================featured collection slider======================//
var topsliders = document.getElementById('featured_products_slider');
var topowl4 = $("#featured_products_slider");
$(topowl4).each(function (index) {
  $(this).owlCarousel({
    items : 4, //10 items above 1000px browser width
    itemsDesktop : [1269,4], //5 items between 1000px and 901px
    itemsDesktopSmall : [989,3], // betweem 900px and 601px
    itemsTablet: [749,3], //2 items between 600 and 0
    itemsMobile : [479,2], // itemsMobile disabled - inherit from itemsTablet option
	afterAction: addfl
  });

  $(".featured_next").click(function(){
    $(topowl4).trigger('owl.next');
  });
  $(".featured_prev").click(function(){
    $(topowl4).trigger('owl.prev');
  });
});

/***************************** Product Tab collection slider ends*****************************/

//======================mobile menu toogle======================//
$(document).ready(function(){

 
  $("#MobileNav .mobile-nav__dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
        $('#MobileNav .mobile_togglecolumn').click(function () {
            $(this).parent().toggleClass('active');
        });
  
   $("#MobileNav .mobile-nav__grand_dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
        $('#MobileNav .mobile-nav__grand__item .mobile_togglecolumn').click(function () {
            $(this).parent().toggleClass('active');
        });
 		
});

//============================ more link ==============================//
function more_left() {
  if ($(window).width() > 1600){
    var max_elem = 7;
    var items = $('.logo-align--left.header-center #SiteNav li.more-site-nav');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--left hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--left .hiden_menu').prepend('<a class="logo--left__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else if ($(window).width() > 1269){
    var max_elem = 5;
    var items = $('.logo-align--left.header-center #SiteNav li.more-site-nav');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--left hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--left .hiden_menu').prepend('<a class="logo--left__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else{
    var max_elem = 4;
    var items = $('.logo-align--left.header-center #SiteNav li.more-site-nav');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--left hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--left .hiden_menu').prepend('<a class="logo--left__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
}
$(document).ready(function() {
    more_left()
});

function more_center() {
  if ($(window).width() > 1600){
    var max_elem = 4;
    var items = $('.logo-align--center.header-left #SiteNav li.more-site-nav');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--center hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--center .hiden_menu').prepend('<a class="logo--center__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else if ($(window).width() > 1269){
    var max_elem = 3;
    var items = $('.logo-align--center.header-left #SiteNav li.more-site-nav');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--center hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--center .hiden_menu').prepend('<a class="logo--center__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else if ($(window).width() > 989){
    var max_elem = 3;
    var items = $('.logo-align--center.header-left #SiteNav li.more-site-nav');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--center hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--center .hiden_menu').prepend('<a class="logo--center__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
}
$(document).ready(function() {
    more_center()
});

//============================ search toggle ==============================//
$(document).ready(function(){
	$(".header-search-btn").click(function(){
	$(".search-header").slideToggle(300); 
    $('.header-search-btn').toggleClass('active'); 
	});
});


// //========================== Product page toggle ==============================//
// /*===================== share product toggle ========================*/
// $(document).ready(function(){
// 	$(".social-sharing-title").click(function(){
// 	$(".social-sharing .share-product").slideToggle(800); 
//     $('.social-sharing').toggleClass('active'); 
// 	});
// });

// /*===================== Porduct description toggle ========================*/
// $(document).ready(function(){
// 	$(".product-details").click(function(){
// 	$(".product-detail__description ul").slideToggle(800); 
//     $('.product-detail__description').toggleClass('active'); 
// 	});
// });

// /*===================== Porduct Review toggle ========================*/
// $(document).ready(function(){
// 	$(".product-reviews").click(function(){
// 	$(".product-description-reviews ul").slideToggle(800); 
//     $('.product-description-reviews').toggleClass('active'); 
// 	});
// });

// /*===================== Porduct size guide toggle ========================*/
// $(document).ready(function(){
// 	$(".product-size-guide").click(function(){
// 	$(".product-description-sizeguide ul").slideToggle(800); 
//     $('.product-description-sizeguide').toggleClass('active'); 
// 	});
// });

